import React from 'react';
import {Box} from '../box';
import {VisibilityBox} from '../box/visibility-box';
import {Typography} from '../typography';

export interface ArtistQuoteProps {
  artistName?: string | null;
  quote?: string | null;
}

export const ArtistQuote: React.FC<ArtistQuoteProps> = ({
  artistName,
  quote,
}: ArtistQuoteProps) => {
  return (
    <Box paddingX={['zero', 'lg']} paddingY="twentyTwo">
      <Box flexDirection="row" height={['61px', '113px']}>
        <VisibilityBox show={[false, true]}>
          <Box flex="1" />
        </VisibilityBox>
        <Box
          flex="fixed"
          backgroundColor="outlines"
          width={['314px', '687px']}
        />
        <Box flex="1" />
        <Box flex="1" />
      </Box>
      <Box flexDirection="row" height={['61px', '113px']} marginY="four">
        <Box
          flex="fixed"
          backgroundColor="outlines"
          width={['186px', '687px']}
        />
        <Box flex="1" />
        <Box flex="1" />
        <Box flex="1" />
      </Box>
      {/* TODO: Add outlined text to theme */}
      <Box paddingX="three">
        <Typography
          color="textDefault"
          textStyle={['h2', 'h2Bold', 'h1Bold']}
          textAlign="center"
          css={{
            WebkitTextStroke: '0.5px white',
            color: 'transparent',
            lineHeight: 1,
          }}
        >
          {`"${quote}"${artistName ? `-${artistName}` : ''}`}
        </Typography>
      </Box>
      <Box flexDirection="row" height={['61px', '113px']} marginY="four">
        <Box flex="1" />
        <Box flex="1" />
        <Box
          flex="fixed"
          backgroundColor="outlines"
          width={['314px', '687px']}
        />
        <VisibilityBox show={[false, true]}>
          <Box flex="1" />
        </VisibilityBox>{' '}
      </Box>
      <Box flexDirection="row" height={['61px', '113px']}>
        <Box flex="1" />
        <Box flex="1" />
        <Box flex="1" />
        <Box
          flex="fixed"
          backgroundColor="outlines"
          width={['186px', '687px']}
        />
      </Box>
    </Box>
  );
};
